import React from 'react';
import { Container } from '../components/Container';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { Section } from '../components/Section';
import { SectionHeading } from '../components/SectionHeading';

export function Newsletter() {
  return (
    <Section id="newsletter" background="var(--gray)">
      <Container fluid>
        <SectionHeading>Newsletter</SectionHeading>
        <NewsletterSignup />
      </Container>
    </Section>
  );
}
